/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 *
 *
 * 1 = Interim (Interim (1, 3, 5, 7, 9, 11))
 *
 * 2 = Main (Main (2, 6, 10))
 *
 * 3 = FullService (Full Service (4, 8, 12))
 *
 * 4 = Annual (Annual (1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12))
 */
export enum ServicePlanVariantType {
  /**
   * Interim (1, 3, 5, 7, 9, 11)
   */
  Interim = 1,
  /**
   * Main (2, 6, 10)
   */
  Main = 2,
  /**
   * Full Service (4, 8, 12)
   */
  FullService = 3,
  /**
   * Annual (1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12)
   */
  Annual = 4,
}
